import {Component, Injector, OnInit} from '@angular/core';
import {BasePropostaComponent} from '../base-proposta';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AppComponent} from '../../../app.component';
import {CategoriaPlanoService} from '../../../core/services/categoria_plano.service';
import {RdService} from '../../../core/services/rd.service';
import {CupomService} from '../../../core/services/cupom.service';
import {PropostaService} from '../../../core/services/proposta.service';
import {CepService} from '../../../core/services/cep.service';
import {Meta, Title} from '@angular/platform-browser';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-pagamento-boleto',
    templateUrl: './pagamento-boleto.component.html',
    styleUrls: ['./pagamento-boleto.component.sass']
})
export class PagamentoBoletoComponent extends BasePropostaComponent implements OnInit {
    public form: FormGroup;

    constructor(
        protected injector: Injector,
        public cupomService: CupomService,
        public propostaService: PropostaService,
        public router: Router,
        private formBuilder: FormBuilder,
        public cepService: CepService,
        public rdService: RdService,
        public toast: ToastrService,
        public categoriaPlanoService: CategoriaPlanoService,
        public appComponent: AppComponent,
        public titleService: Title,
        public meta: Meta,
        public deviceService: DeviceDetectorService
        ) {
        super(injector);
        const proposta = this.getPropostaParaStorage();

        this.form = formBuilder.group({
            debitoDataPagamento: new FormControl(proposta ? proposta.debitoDataPagamento : null, [Validators.required]),
            bairro: new FormControl(proposta ? proposta.bairro : null, [Validators.required]),
            cep: new FormControl(proposta ? proposta.cep : null, [Validators.required]),
            codCidade: new FormControl(proposta ? proposta.codCidade : null, [Validators.required]),
            complemento: new FormControl(proposta ? proposta.complemento : null, []),
            logradouro: new FormControl(proposta ? proposta.logradouro : null, [Validators.required]),
            numero: new FormControl(proposta ? proposta.numero : null, [Validators.required]),
            termoDeUsoAceito: new FormControl(null, [Validators.required]),
        });

        this.carregarEnderecoLocalStorage(this.form);
        this.carregarContaLocalStorage();
    }

    showError(campo) {
        return this.form.controls[campo].errors && !this.form.controls[campo].pristine;
    }

    carregarContaLocalStorage() {
        const proposta = this.getPropostaParaStorage();

        if (!proposta) {
            return;
        }

        if (proposta.debitoDataPagamento) {
            this.form.get('debitoDataPagamento').setValue(proposta.debitoDataPagamento.padStart(2, '0'));
        }
    }

    async submit() {

        if (this.form.valid) {
            const result = await this.propostaService.pagamentoBoleto(this.form.value);

            if (result.status === 200 || result.status === 201) {
                const queryRD = {
                    event_type: 'CONVERSION',
                    event_family: 'CDP',
                    payload: {
                        conversion_identifier: 'Carrinho_Site_Passo_2',
                        email: this.emailCliente,
                        cf_bairro: this.form.get('bairro').value,
                        cf_cep: this.form.get('cep').value,
                        cf_complemento: this.form.get('complemento').value,
                        cf_endereco: this.form.get('logradouro').value,
                        cf_numero: this.form.get('numero').value,
                        cf_tipobanco: 'Boleto Bancário'
                    }
                };

                this.rdService.updateEventByIdentifier(queryRD);

                this.addPropostaParaStorage(this.form.value);
                this.router.navigate(['seguranca']);
            } else if (result.status === 400 || result.status === 409) {
                this.toast.error(result.error.description);
            } else {
                if (result.error) {
                    this.toast.error(result.error.description, '', {
                        timeOut: 5000
                    });
                } else {
                    this.toast.error('Ocorreu um erro ao processar a requisição', '', {
                        timeOut: 8000
                    });
                }
            }
        }
    }

    termoDeUsoAceitoEmit($event) {
        this.form.get('termoDeUsoAceito').setValue($event ? true : null);
    }

    getErrorMessage(field: string) {

        const input = this.form.get(field);
        return input.hasError('required') ? 'Campo obrigatório' :
            input.hasError('cpf') ? 'CPF inválido' :
                input.hasError('invalidDate') ? 'Insira uma data válida.' :
                    input.hasError('notSame') ? 'E-mail não confere.' :
                        input.hasError('email') ? 'E-mail inválido.' :
                            '';
    }

    async ngOnInit() {
        await this.inOnInit();
    }
}
